import QRCode from 'qrcode'
import { drawCameraIcon } from './drawCameraIcon'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const drawLabel = async (args = {}) => {
    const {
        orderId,
        total,
        pos,
        color,
        size,
        side,
        posColor,
        posBackground,
        sideColor,
        sideBackground,
        type,
        code,
        loc,
        noCard,
        isSpecialTag,
        brand_name,
        is_no_card,
        line_ship_label,
        overtime,
        tagMTUS,
        hwUSPSArea,
        isFastProduction,
        isCutoff,
        isHQ,
        order_type,
        isCombineShip,
        isCombo,
        comboTag = [],
        genericTags = [],
        tags = [],
        combineShipId,
    } = { ...args }
    const arrCountry = [
        'GB', 'AT', 'BE', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
        'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'NL', 'NO', 'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'CH', 'CA',
    ]
    const sizeUVHEART = [
        { '1 HOLDER+ 2 CANDLES': '1HD + 2CD' },
        { '1 HOLDER+ 4 CANDLES': '1HD + 4CD' },
        { '1 HOLDER+ 6 CANDLES': '1HD + 6CD' },
        { '1 HOLDER+ 8 CANDLES': '1HD + 8CD' },
        { '1 HOLDER+ 10 CANDLES': '1HD + 10CD' },
        { '1 HOLDER+ 15 CANDLES': '1HD + 15CD' },
        { '1 HOLDER+ 20 CANDLES': '1HD + 20CD' },
    ]

    const sizeAcrylicPlaque = {
        '3.9in puzzle left': '3.9 Puzzle L',
        '4.9in puzzle left': '4.9 Puzzle L',
        '5.9in puzzle left': '5.9 Puzzle L',

        '3.9in puzzle right': '3.9 Puzzle R',
        '4.9in puzzle right': '4.9 Puzzle R',
        '5.9in puzzle right': '5.9 Puzzle R',

        '3.9in heart left': '3.9 Heart L',
        '4.9in heart left': '4.9 Heart L',
        '5.9in heart left': '5.9 Heart L',

        '3.9in heart right': '3.9 Heart R',
        '4.9in heart right': '4.9 Heart R',
        '5.9in heart right': '5.9 Heart R',
    }

    const LABEL_WIDTH = 300
    const LABEL_HEIGHT = 300

    const MID_X = 130
    const QR_WIDTH = 135
    const QR_Y = 55

    const qrDataUrl = await QRCode.toDataURL(orderId, {
        width: 200, margin: 3, color: isSpecialTag ? {
            dark: '#6d1212',
            light: '#ffffffff',
        } : '',
    })
    const qrDataImage = await _makeImage(qrDataUrl)

    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT

    const ctx = canvas.getContext('2d')

    ctx.beginPath()
    ctx.rect(0, 0, LABEL_WIDTH, LABEL_HEIGHT)
    ctx.fillStyle = 'white'
    ctx.fill()

    ctx.drawImage(qrDataImage, 0, QR_Y, QR_WIDTH, QR_WIDTH)

    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = '22px Arial'
    ctx.fillText(orderId, 12, 30)

    ctx.beginPath()
    ctx.fillStyle = posBackground
    ctx.rect(MID_X + 40, 12, QR_WIDTH, 20)
    ctx.fill()

    ctx.fillStyle = posColor
    ctx.fillText(`${pos}/${total}`, MID_X + 50, 30)

    ctx.beginPath()
    ctx.fillStyle = sideBackground
    ctx.rect(MID_X, QR_Y + 83, QR_WIDTH, 25)
    ctx.fill()

    // if (overtime) {
    ctx.beginPath()
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.rect(15, QR_Y + 125, 105, 25)
    ctx.fill()
    // }

    if (type.length < 15) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '22px Arial'
        ctx.fillText(type, 12, 55)
    } else if (type.length >= 15 && type.length < 20) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '20px Arial'
        ctx.fillText(type, 12, 55)
    } else {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '14px Arial'
        ctx.fillText(type, 12, 55)
    }

    ctx.beginPath()
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    if (brand_name) {
        if (brand_name.length < 10) {
            ctx.font = 'bolder 25px Arial'
        } else {
            ctx.font = 'bolder 20px Arial'
        }
        ctx.fillText(brand_name, MID_X, QR_Y + 127)
    }


    ctx.beginPath()
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = '25px Arial'

    if (color) {
        ctx.fillText(color, MID_X, QR_Y + 33)
    }

    if (size) {
        let sizeUV = size
        if ((size !== 'Default' && size !== 'DEFAULT') && (type === 'UV_HEART_HOLDER' || type === 'UV_HOLDER' || type === 'UV_HOLDER_CANDLE' || type === 'UV_HEART_HOLDER_CANDLE')) {
            const sizeObject = sizeUVHEART.find(item => item[size])
            sizeUV = sizeObject[size]
        }

        if (['ACRYLIC_PLAQUE'].includes(type)) {
            const vSize = size.trim().toLowerCase()
            sizeUV = sizeAcrylicPlaque[vSize]
        }

        const lines = sizeUV.split(/[+-]/)
        for (var i = 0; i < lines.length; i++) {
            ctx.fillText(lines[i].trim(), MID_X, (QR_Y + 55) + (22 * i))
        }

        // ctx.fillText(sizeUV, MID_X, QR_Y + 48)
    }

    //Qua han
    // if (overtime) {
    ctx.fillStyle = 'white'
    ctx.fillText(overtime ? `QH ${overtime}` : '', 15, 203, 105)
    // }

    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    if (loc) {
        // if (overtime) {
        ctx.fillText(arrCountry.includes(loc) ? 'EU' : loc, 15, 230)
        // } else {
        //     ctx.fillText(arrCountry.includes(loc) ? 'EU' : loc, 15, 230)
        // }
    }

    //Ship line
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = 'bolder 26px Arial'
    // if (overtime) {
    ctx.fillText(line_ship_label, 15, 252)
    // } else {
    //     ctx.fillText(line_ship_label, 15, 252)
    // }

    // Đơn tiktok chắc chắn là nhanh -> chỉ hiện TIKTOK.
    // Đơn nhanh (không phải tiktok) -> hiện NHANH.
    // Hai text này không xuất hiện đồng thời; text dời sang vị trí TIKTOK cũ.
    const bottomTagY = line_ship_label
        ? ((isCombineShip || isCombo) ? 300 : 277)
        : ((isCombineShip || isCombo) ? 276 : 250)

    // Icon máy ảnh nằm ở vị trí text NHANH cũ (bên trái) — chỉ hiện khi đơn đang
    // chờ chụp ảnh (photo_requested), KHÔNG hiện cho photo_updated/confirmed.
    // Cao bằng chữ, nền trong suốt (overlay).
    const PHOTO_TAGS = ['photo_requested']
    const isRequestPhoto = [...genericTags, ...tags].some(t => PHOTO_TAGS.includes(t))
    if (isRequestPhoto) {
        const camSize = 18
        drawCameraIcon(ctx, 15, bottomTagY - camSize, camSize)
    }

    ctx.font = 'bolder 24px Arial'
    const textX = 15 + ctx.measureText('NHANH').width + 15
    if (order_type && order_type.toLowerCase() === 'tiktok') {
        ctx.fillStyle = 'red'
        ctx.fillText('TIKTOK', textX, bottomTagY)
    } else if (isFastProduction) {
        ctx.fillStyle = 'black'
        ctx.fillText('NHANH', textX, bottomTagY)
    }

    if (isCutoff) {
        ctx.fillStyle = 'black'
        ctx.font = 'bolder 24px Arial'
        const text = 'CUTOFF'
        const textWidth = ctx.measureText(text).width
        // ctx.fillText(text, canvas.width - textWidth, overtime ? 230 : 200)

        // if (overtime) {
        if (line_ship_label) {
            ctx.fillText(text, canvas.width - textWidth, (isCombineShip || isCombo || genericTags.includes('cutoff_noel') || genericTags.includes('cutoff_new_year')) ? 300 : 277)
        } else {
            ctx.fillText(text, canvas.width - textWidth, (isCombineShip || isCombo || genericTags.includes('cutoff_noel') || genericTags.includes('cutoff_new_year')) ? 276 : 250)
        }
        // } else {
        //     if (line_ship_label) {
        //         ctx.fillText(text, canvas.width - textWidth, tagMTUS ? 273 : 248)
        //     } else {
        //         ctx.fillText(text, canvas.width - textWidth, tagMTUS ? 245 : 220)
        //     }
        // }
    }
    //Cutoff noel
    if (genericTags.includes('cutoff_noel')) {
        ctx.fillStyle = 'black'
        ctx.font = 'bolder 17px Arial'
        const textWidth = ctx.measureText('NOEL').width
        if (line_ship_label) {
            ctx.fillText(`NOEL`, canvas.width - textWidth, 275)
        } else {
            ctx.fillText(`NOEL`, canvas.width - textWidth, 252)
        }
    }

    //Cutoff new year
    if (genericTags.includes('cutoff_new_year')) {
        ctx.fillStyle = 'black'
        ctx.font = 'bolder 17px Arial'
        const textWidth = ctx.measureText('NEW YEAR').width
        if (line_ship_label) {
            ctx.fillText(`NEW YEAR`, canvas.width - textWidth, 275)
        } else {
            ctx.fillText(`NEW YEAR`, canvas.width - textWidth, 252)
        }
    }

    if (hwUSPSArea) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = 'bolder 26px Arial'

        ctx.fillText(hwUSPSArea, 15 + ctx.measureText(line_ship_label).width + 25, overtime ? 252 : 252)
    }

    //tag MT_US_NHE
    // ctx.fillStyle = isSpecialTag ? '#6d1212' : 'red'
    ctx.font = 'bolder 22px Arial'
    // ctx.fillStyle = 'red'
    // if (overtime) {
    if (isCombineShip || isCombo) {
        if (line_ship_label) {
            // Gộp ship
            ctx.fillText(`${(isCombo ? comboTag[0] : 'GỘP')} ${combineShipId}`, 15, 275)
        } else {
            // Gộp ship
            ctx.fillText(`${(isCombo ? comboTag[0] : 'GỘP')} ${combineShipId}`, 15, 252)
        }
    }
    // } else {
    //     if (line_ship_label) {
    //         ctx.fillText(tagMTUS, 15, 248)
    //     } else {
    //         ctx.fillText(tagMTUS, 15, 220)
    //     }
    // }

    ctx.fillStyle = sideColor ? sideColor : sideBackground === 'black' ? 'white' : 'black'
    ctx.fillText(side, MID_X, QR_Y + 105)

    if (![...genericTags, ...tags].includes('made_vn') && (noCard || is_no_card)) {
        ctx.font = 'bolder 26px Arial'
        ctx.fillText('No Card', MID_X, QR_Y + 153)
    }
    if ([...genericTags, ...tags].includes('made_vn')) {
        ctx.fillStyle = 'black'
        ctx.font = 'bolder 22px Arial'
        ctx.fillText(`Made in VN`, MID_X, QR_Y + 153)
    }

    if (isHQ) {
        ctx.fillStyle = 'red'
        ctx.font = 'bolder 20px Arial'
        if (line_ship_label) {
            if (isCombineShip || isCombo) {
                ctx.fillText('HQ gap', ctx.measureText(line_ship_label).width + 15, 296)
            } else {
                ctx.fillText('HQ gap', 15, 295)
            }
        } else {
            ctx.fillText('HQ gap', 15, 295)
        }
    }

    return canvas.toDataURL()
}

export default drawLabel
